// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__33sHV","radioRow":"SimpleQuestionBuilderModal_radioRow__3kwZG"};